import { GWidget } from "./GWidget";
import { Layout } from "./layout/Layout";
import { UIEvent } from "./UIEvent";
export class GBox extends GWidget {
    constructor(layoutClass) {
        super();
        this._layout = new (layoutClass || Layout)(this);
    }
    get layout() {
        return this._layout;
    }
    setLayoutChangedFlag(reason) {
        var _a;
        (_a = this._layout) === null || _a === void 0 ? void 0 : _a.setChangedFlag(reason);
    }
    _sizeChanged(changeByLayout) {
        if (changeByLayout)
            this._layout.refresh();
    }
}
